export const theme = {
  colors: {
    primary: '#004386',
    secondary: '#fce3d9',
  },
};
